import { render, staticRenderFns } from "./sitemanage.vue?vue&type=template&id=5a420bfc&scoped=true&"
import script from "./sitemanage.vue?vue&type=script&lang=js&"
export * from "./sitemanage.vue?vue&type=script&lang=js&"
import style0 from "./sitemanage.vue?vue&type=style&index=0&id=5a420bfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a420bfc",
  null
  
)

export default component.exports